var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Hero'),_c('AppTeaser'),_c('SbuTeaser'),_c('Weiterbildung'),_c('Downlaods'),(_vm.$store.compShowByDate)?_c('Contact'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }